import React from "react";
import poweredByLinkStyles from './AlmePoweredByLink.styles';
import { Button, Container } from "@material-ui/core";
import { WithStyles, withStyles } from '@material-ui/core/styles';
import { FocusComponentProps } from "../../models/ComponentProps";
import { AlmePoweredByLinkConfig } from "./AlmePoweredByLInkConfig";

interface AlmePoweredByLinkProps extends WithStyles<typeof poweredByLinkStyles> {
    almeConfig: AlmePoweredByLinkConfig;
    focusProps?: FocusComponentProps;
}

const AlmePoweredByLink: React.FC<AlmePoweredByLinkProps> | null = (props: AlmePoweredByLinkProps) => {
    if (props.almeConfig.poweredByLink.isEnabled) {
        return (
            <Container disableGutters className={props.classes.linkContainer}>
                <Button variant='text' size='small' color='default'
                    {...props.focusProps}
                    target='_blank'
                    href={props.almeConfig.poweredByLink.url}
                >Powered by <span style={{ fontWeight: 'bold', textTransform: 'uppercase' }}>&nbsp;Verint</span></Button>
            </Container>
        );
    }
    else
        return null;

};
export default withStyles(poweredByLinkStyles)(AlmePoweredByLink);